export default {"src":"/_next/static/media/csbGear.e6182247.svg","height":450,"width":450,"blurWidth":0,"blurHeight":0};